<div *ngIf="(chartData$ | async) as chartData" class="trend-chart">
  <app-trend-chart-description [chartShortHand]="chart.shortHand"
                               [title]="title"
                               [typographySize]="typographySize"></app-trend-chart-description>
  <app-chart [chart]="chart" [dataPoints]="chartData.data"></app-chart>
</div>
